export const EVENT_DETAIL_TABS_INFO = [
    "Información general del evento",
    "Días de evento"
];